import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'second-meeting-first-step',
  templateUrl: './second-meeting-first-step.component.html',
  styleUrls: ['../../meeting-form.component.scss']
})
export class SecondMeetingFirstStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
